import { Outlet } from "react-router-dom";
import { SurfSidebar } from "./SurfSidebar";

export function SurfShell() {
  return (
    <div className="surf-workspace">
      <SurfSidebar />
      <main className="surf-main">
        <Outlet />
      </main>
    </div>
  );
}
